// src/components/CustomCard.js
import React from "react";
import { Card, Typography } from "@mui/material";
import "./dashboard.style.css";

const DashboardCard = ({
  CardImage,
  CardCount,
  CardTitle,
  CardBackgroundColor,
  CountBackgroundColor,
  OnPressNavigate
}) => {
  return (
    <Card
      elevation={2}
      style={{
        backgroundColor: CardBackgroundColor,
      }}
      onClick={OnPressNavigate}
      className="cursor-pointer"
    >
      <div className="card-image-and-count-div">
        <div className="card-image-div">
          <img
            src={CardImage}
            alt={CardTitle}
            className="card-image-height-width"
          />
        </div>
        <div
          className="card-count-div"
          style={{
            backgroundColor: CountBackgroundColor,
          }}
        >
          <Typography className="inter-semi-bold-600 count-font-size">
            {CardCount}
          </Typography>
        </div>
      </div>
      <div className="card-title-div">
        <Typography className="inter-medium-500 title-font-size">
          {CardTitle}
        </Typography>
      </div>
    </Card>
  );
};

export default DashboardCard;
